export const foreignKeyMapping = {
  contacts: "contact_id",
  projects: "project_id",
};
